import { INVITE_MESSAGE_LENGTH_PREFIX_BYTES } from '../../constants/message';

/**
 * Deserializes an invitation payload buffer into its components.
 * Expects the buffer to be formatted as:
 * - 1 byte: version (must be 1)
 * - 1 byte: message length prefix (uint8)
 * - N bytes: kyberPublicKey (remaining bytes after slicing out message)
 * - M bytes: message (as specified by prefix, UTF-8 encoded)
 *
 * @param data - The serialized invitation payload buffer
 * @returns An object containing the version, kyberPublicKey, and message string
 */

export function deserializeHandshakeRequestPayload(data: Uint8Array): {
  version: number;
  kyberPublicKey: Uint8Array;
  message: string;
} {

  if (data.length < 2) {
    throw new Error('Invite payload too short');
  }

  // Read version
  const version = data[0];
  if (version !== 1) {
    throw new Error(`Unsupported invite version: ${version}`);
  }

  // Read message length
  const msgLen = data[1];

  // Extract Kyber public key
  const kyberPublicKey = data.slice(2, data.length - msgLen);

  // Extract message
  const messageBytes = data.slice(data.length - msgLen);
  const message = new TextDecoder().decode(messageBytes);

  return {
    version,
    kyberPublicKey,
    message,
  };
}